/**
 * Bypass-flag context — read by prod components (`AuthGuard`,
 * `PermissionGate`) to decide whether to short-circuit. Only ever
 * *populated* in dev, via `src/dev/DevSettingsProvider`. In prod the
 * context stays at its `null` default, so both bypass flags read as
 * `false` and the auth/permission paths run unchanged.
 *
 * Living here (not in `src/dev/`) lets prod components import without
 * pulling any dev-only code into the bundle.
 */
import { createContext, useContext } from 'react'

export interface BypassFlags {
  readonly authBypass: boolean
  readonly permissionBypass: boolean
}

export const BypassFlagsContext = createContext<BypassFlags | null>(null)

export function useBypassFlags(): BypassFlags {
  const ctx = useContext(BypassFlagsContext)
  return ctx ?? { authBypass: false, permissionBypass: false }
}
